import { z } from 'zod';
import { sanitizeName } from '@/shared/utils/sanitize-name';

// Draft name validation
const draftNameValidation = z
  .string()
  .min(1, 'Draft name is required')
  .max(100, 'Draft name must be at most 100 characters')
  .transform(sanitizeName)
  .refine(val => val.length >= 2, 'Draft name must be at least 2 characters');

export const draftRenameSchema = z.object({
  displayName: draftNameValidation,
});

export type DraftRenameFormData = z.infer<typeof draftRenameSchema>;
